import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const LogoutPage = () => {
  const navigate = useNavigate();
  const logoSrc = "./UNextMABLogo06.png";

  useEffect(() => {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = () => {
      navigate("/logout", { replace: true });
    };
  }, [navigate]);

  return (
    <div style={styles.pageContainer}>
      <div style={styles.logoutBox}>
      <img src={logoSrc} alt="Logo" style={styles.logo} />
        <h5 style={styles.message}>
        Thank you for your participation! Your responses have been recorded successfully.
        Our team is currently processing your results, and it would be shared with you shortly.
        If you have any questions or need further assistance,please feel free to contact us at survey360@u-next.com
        </h5>

        <footer style={styles.footer}>
          &copy; 2025 UNext Learning Pvt Ltd. All rights reserved.
        </footer>
     
        </div>

   
    </div>
  );
};

const styles = {
  pageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "50vh",
    width:"500px",

    
  },

  logo: {
    width: "150px", // Adjust the size of the logo as needed
    margin: "0 auto 20px auto",
    display: "block",
  },
  logoutBox: {
    width: "90%",
    maxWidth: "600px",
    padding: "20px",
    textAlign: "center",
    backgroundColor:" #0A0A0A",
    borderRadius: "20px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
border: "5px solid #FFFFFF",
    
    
  },
  message: {
    
    fontSize: "12px",
    color: "#FFFFFF",
    margin: "10px 0",
    lineHeight: "1.5",
  },

footer: {
    position: "absolute",
    bottom: "10px",
    left: "50%",
    transform: "translateX(-50%)",
    color: "black",
    fontSize: "10px",
  },
};

export default LogoutPage;
